<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>银行信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="提示: 维护账户信息，后续您向合作企业提供付款账号时，可快速复制。">
			</el-alert>
		</div>
		<el-row class="mg-b5">
			<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="bankNumber" label="银行账号" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="bankGjCode" label="银行国家代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="name" label="银行名称" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="bankLineNum" label="银行行号" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="khhName" label="开户行名称" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="accountName" label="账户名称" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="isMainNum" label="是否主账号" :formatter="formatIsMainNum"> </el-table-column>
				<el-table-column label="操作" width="100" align="center" fixed="right">
					<template slot="header" slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleAdd" >新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)" >修改
						</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row.rowId)" >删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
		<el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
			<el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="12">
						<el-form-item label="银行账号" prop="bankNumber">
							<el-input v-model.number="form.bankNumber" placeholder="请输入银行账号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="银行国家代码" prop="bankGjCode">
							<el-input v-model="form.bankGjCode" placeholder="请输入银行国家代码" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="银行名称" prop="name">
							<el-input v-model="form.name" placeholder="请输入银行名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="银行行号" prop="bankLineNum">
							<el-input v-model="form.bankLineNum" placeholder="请输入银行行号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开户行名称" prop="khhName">
							<el-input v-model="form.khhName" placeholder="请输入开户行名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="账户名称" prop="accountName">
							<el-input v-model="form.accountName" placeholder="请输入账户名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否主账号" prop="isMainNum">
							<el-radio-group v-model="form.isMainNum">
								<el-radio :label="0">是</el-radio>
								<el-radio :label="1">不是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		supplierBankIdList,
		addSupplierBankID,
		editSupplierBankID,
		delSupplierBankID,
	} from '@/api/gys/supplierBankId.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { createHash } from '@/utils/index'
	export default {
		name: "BankInfo",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				ids: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					bankNumber: [{
						required: true,
						type: 'number',
						message: '请输入银行账号',
						trigger: 'blur'
					}],
					khhName: [{
						required: true,
						message: '请输入开户行名称',
						trigger: 'blur'
					}],
					accountName: [{
						required: true,
						message: '请输入账户名称',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList();
			},
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierBankID',
					classTypeIndex:'0',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
					}
				})
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					hId: this.basicId,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					bankNumber: undefined,
					bankGjCode: undefined,
					name: undefined,
					bankLineNum: undefined,
					khhName: undefined,
					accountName: undefined,
					isMainNum: 0,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let oldData = JSON.parse(JSON.stringify(_this.tableData))
						let data = JSON.parse(JSON.stringify(_this.form));
						if (data.rowId != undefined) {
							let num = -1;
							oldData.forEach((nItem,index)=>{
								if(nItem.rowId == data.rowId){
									num = index;
								}
							})
							if(num>=0){
								oldData[num] = data;
							}
							_this.addFun(oldData);
						} else {
							data.rowId = createHash();
							oldData.push(data)
							_this.addFun(oldData);
						}
					}
				});
			},
			addFun(data){
				let _this = this;
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierBankID',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(data)
				}).then((res)=>{
					_this.$success('添加成功');
					_this.openDialog = false;
					_this.getList();
				})
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 4);
			},
			//下一步
			nextStep: function() {
				if (this.tableData.length <= 0) {
					this.$notify({
						message: '请至少输入一条银行信息',
						type: 'error'
					});
					return false;
				}
				this.bus.$emit('stepsFun', 6);
			},

			handleDel: function(id) {
				let _this = this;
				let oldData = JSON.parse(JSON.stringify(_this.tableData))
				let newData = [];
				oldData.forEach((item)=>{
					if(item.rowId != id){
						newData.push(item)
					}
				})
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						_this.addFun(param);
					},
					data:newData//参数对象 主要回调函数用
				});
			},
			formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},

		}
	};
</script>
<style scoped="scoped">
</style>
